import React from 'react';
import styles from './tabs.module.scss';

interface TabProps {
  title: string;
  selected?: boolean;
  onSelected: Function;
}

interface TabHeaderProps {
  fullHeight?: boolean;
}

export const TabSelector: React.FC<TabProps> = ({
  title,
  selected = false,
  onSelected
}) => (
  <div
    className={`${styles.tabTitle} ${selected ? styles.selected : ''}`}
    onClick={() => onSelected()}
  >
    {title}
  </div>
);

export const TabBody: React.FC = ({ children }) => <div>{children}</div>;

export const TabHeader: React.FC<TabHeaderProps> = ({
  fullHeight,
  children
}) => (
  <div
    className={`${styles.tabContainer} ${fullHeight ? styles.fullHeight : ''}`}
  >
    {children}
  </div>
);
